import { FC } from 'react'

type Props = {
  color?: string
  className?: string
  fill?: string
}

const ShippedStatus: FC<Props> = ({ className, color, fill }) => {
  return (
    <svg
      className={className}
      width="62"
      height="31"
      viewBox="0 0 62 31"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.7502 14.87V26.86H56.3502C56.4002 26.57 56.4302 26.27 56.4302 25.96C56.4302 22.91 53.9602 20.44 50.9202 20.44C47.8802 20.44 45.4102 22.91 45.4102 25.96C45.4102 26.27 45.4402 26.57 45.4902 26.86H33.6802C33.7402 26.57 33.7602 26.27 33.7602 25.96C33.7602 22.91 31.3002 20.44 28.2502 20.44C25.2002 20.44 22.7402 22.91 22.7402 25.96C22.7402 26.27 22.7702 26.57 22.8202 26.86H17.9102V1H48.8502L57.0402 12.68L60.7502 14.87Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M22.8202 26.8599C22.7702 26.5699 22.7402 26.2699 22.7402 25.9599C22.7402 22.9099 25.2102 20.4399 28.2502 20.4399C31.2902 20.4399 33.7602 22.9099 33.7602 25.9599C33.7602 26.2699 33.7402 26.5699 33.6802 26.8599"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.4902 26.8599C45.4402 26.5699 45.4102 26.2699 45.4102 25.9599C45.4102 22.9099 47.8802 20.4399 50.9202 20.4399C53.9602 20.4399 56.4302 22.9099 56.4302 25.9599C56.4302 26.2699 56.4002 26.5699 56.3502 26.8599"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M28.2505 29.51C30.1504 29.51 31.6905 27.9699 31.6905 26.07C31.6905 24.1701 30.1504 22.63 28.2505 22.63C26.3507 22.63 24.8105 24.1701 24.8105 26.07C24.8105 27.9699 26.3507 29.51 28.2505 29.51Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M50.9205 29.51C52.8203 29.51 54.3605 27.9699 54.3605 26.07C54.3605 24.1701 52.8203 22.63 50.9205 22.63C49.0206 22.63 47.4805 24.1701 47.4805 26.07C47.4805 27.9699 49.0206 29.51 50.9205 29.51Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.9395 4.73999V12.97H53.2395L48.0795 4.73999H45.9395Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1198 9.81995H4.50977"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.61 13.9299H1"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4596 18.0399H4.84961"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default ShippedStatus
